import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import {
	NextInvoicePreviewResponse,
	OperationResult,
	UpgradePreviewRequest,
} from '../../../admin/components/tools/UpgradeWizard/types';

export function useNextInvoicePreviewMutation() {
	const userSession = useAdminUserSession();

	return useMutation({
		mutationFn: async (request: UpgradePreviewRequest) => {
			const response = await userSession.webServiceHelper.callAsync<OperationResult<NextInvoicePreviewResponse>>(
				'admin/BillingUtilities/PreviewNextInvoiceAfterUpgrade',
				'POST',
				request
			);

			// Handle both wrapped response { success, value } and unwrapped response
			if ('value' in response && 'success' in response) {
				if (!response.success || !response.value) {
					throw new Error(response.error || 'Failed to preview next invoice');
				}
				return response.value;
			}

			return response as unknown as NextInvoicePreviewResponse;
		},
	});
}
